import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Typography, Paper, Grid } from '@mui/material';
import { useStore } from '../stores';
import DashboardLayout from '../components/layout/DashboardLayout/DashboardLayout';
import DriversList from '../components/common/QuotaProgressBar';
import WorkHoursProgress from '../components/charts/WorkHoursProgress';
import EstimatedIncomeProgress from '../components/charts/EstimatedIncomeProgress';
import ExchangeRateHistory from '../components/common/ExchangeRateHistory';
import ExchangeRateCard from '../components/common/ExchangeRateCard';
import GrossEarningsCard from '../components/common/GrossEarningsCard';
import WorkHoursHistory from '../components/common/WorkHoursHistory';

const Balance: React.FC = () => {
    const { authStore } = useStore();

    const SAMPLE_DRIVERS = [
        {
            id: '1',
            name: 'John Doe',
            code: 'AE12345',
            dailyQuota: {
                current: 30,
                total: 30
            }
        },
        {
            id: '2',
            name: 'John Doe',
            code: 'AE12345',
            dailyQuota: {
                current: 14,
                total: 30
            }
        },
        {
            id: '3',
            name: 'John Doe',
            code: 'AE12345',
            dailyQuota: {
                current: 14,
                total: 30
            }
        },
        {
            id: '4',
            name: 'Jane Smith',
            code: 'AE67890',
            dailyQuota: {
                current: 22,
                total: 30
            }
        },
        {
            id: '5',
            name: 'Miguel Rodriguez',
            code: 'AE54321',
            dailyQuota: {
                current: 7,
                total: 30
            }
        }
    ];

    const exchangeRateData = [
        {
            date: 'Jueves, 17 de Julio de 2025',
            rate: '111,49 Bs.S'
        },
        {
            date: 'Miércoles, 16 de Julio de 2025',
            rate: '121,49 Bs.S'
        },
        {
            date: 'Martes, 15 de Julio de 2025',
            rate: '121,49 Bs.S'
        }
    ];

    const workHoursData = [
        {
            date: 'Jueves, 17 de Julio de 2025',
            hours: '9,7 Horas',
            status: 'success' as const
        },
        {
            date: 'Miércoles, 16 de Julio de 2025',
            hours: '4,7 Horas',
            status: 'failure' as const
        },
        {
            date: 'Martes, 15 de Julio de 2025',
            hours: '9,7 Horas',
            status: 'success' as const
        }
    ];

    const handleReportClick = () => {
        console.log('Reporte clickeado - generar informe');
    };

    const handleEditEntry = (entry: any) => {
        console.log('Editar entrada:', entry);
    };

    const handleCalendarClick = () => {
        console.log('Calendario clickeado - abrir selector de fechas');
    };

    const handleDriverSelect = (driver: any) => {
        console.log('Conductor seleccionado:', driver);
    };

    const handleExpandClick = () => {
        console.log('Expandir o navegar a detalles de ganancias');
    };

    return (
        <DashboardLayout>
            <Box>
                <Typography variant="h4" sx={{ mb: 3 }}>
                    Balances
                </Typography>

                <Grid container spacing={3}>
                    <Grid size={{ xs: 12, md: 7, lg: 7, xl: 7 }}>
                        <Box sx={{ mb: 3 }}>
                            <DriversList
                                drivers={SAMPLE_DRIVERS}
                                onDriverSelect={handleDriverSelect}
                                maxHeight={500}
                            />
                        </Box>

                        <Box sx={{ mb: 3 }}>
                            <ExchangeRateHistory
                                entries={exchangeRateData}
                                onCalendarClick={handleCalendarClick}
                            />
                        </Box>
                        <Box>
                            <WorkHoursHistory
                                entries={workHoursData}
                                onCalendarClick={handleCalendarClick}
                                onReportClick={handleReportClick}
                                onEditEntry={handleEditEntry}
                            />
                        </Box>
                    </Grid>

                    <Grid size={{ xs: 12, md: 5, lg: 5, xl: 5 }}>
                        <Grid container spacing={2} sx={{ mb: 3 }}>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <WorkHoursProgress
                                    current={4}
                                    total={8}
                                    title="Horas trabajadas hoy"
                                />
                            </Grid>

                            <Grid size={{ xs: 12, sm: 6 }}>
                                <EstimatedIncomeProgress
                                    current={4}
                                    total={8}
                                    amount="35,5$"
                                    subtitle="Según la tasa del día"
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} sx={{ mb: 3 }}>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <WorkHoursProgress
                                    current={14}
                                    total={30}
                                    title="Carreras de hoy"
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ mb: 3 }}>
                            <Grid size={{ xs: 12, sm: 12 }}>
                                <ExchangeRateCard
                                    rate="100,00 Bs.S"
                                    lastUpdate="Jueves 17 a las 12:12 a.m"
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <GrossEarningsCard
                                    amount="3.500,00 Bs.s"
                                    onExpandClick={handleExpandClick}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <GrossEarningsCard
                                    amount="3.500,00 Bs.s"
                                    onExpandClick={handleExpandClick}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <GrossEarningsCard
                                    amount="3.500,00 Bs.s"
                                    onExpandClick={handleExpandClick}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <GrossEarningsCard
                                    amount="3.500,00 Bs.s"
                                    onExpandClick={handleExpandClick}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </DashboardLayout>
    );
};

export default observer(Balance);